import Box from "react-raster";
import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import ButtonLink from "../ButtonLink";
import { ContainerWrapper } from "../Container";
import { H3 } from "../Typography";

const FullWidthWrapper = styled.div`
  text-align: center;
`;

const LogosWrapper = styled(ContainerWrapper)`
  text-align: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  gap: 10px;
  @media (max-width: 768px) {
    display: grid;
    grid-gap: 80px;
    justify-items: center;
  }
`;

const LogosImage = styled(GatsbyImage)`
  width: 25%;
  @media (max-width: 768px) {
    width: 50%;
  }
`;

function PartnershipLogos({ ctaLabel, ctaUrl, logos, title }) {
  return (
    <FullWidthWrapper>
      <Box cols={[6, 12]} marginTop={["70px", "125px"]}>
        <Box cols={[6, 12]} marginBottom={["70px", "122px"]}>
          <H3>{title}</H3>
        </Box>
        <Box cols={[6, 12]} marginBottom={["70px", "122px"]}>
          <LogosWrapper>
            {logos?.map((logo) => {
              return (
                <LogosImage
                  key={logo.id}
                  image={getImage(logo)}
                  alt={logo.description}
                  objectFit="fill"
                />
              );
            })}
          </LogosWrapper>
        </Box>
        {ctaUrl && (
          <Box cols={[6, 12]} marginBottom={["70px", "175px"]}>
            <ButtonLink isWhite label={ctaLabel} url={ctaUrl} />
          </Box>
        )}
      </Box>
    </FullWidthWrapper>
  );
}

export default PartnershipLogos;
